<template>
    <div class="col-md-12 px-2 py-0 mt-5">
        <draggable
            :list="arrayModels"
            class="list-group"
            ghost-class="ghost"
            @start="dragging = true"
            @end="dragging = false"
        >
            <div
                class="list-group-item"
                v-for="element in arrayModels"
                :key="element.id"
            >
                <div class="form-group form-check col-md-12">
                    <input
                        type="checkbox"
                        class="form-check-input"
                        :id="'question_' + element.id"
                        :value="element.is_visible"
                        v-model="element.is_visible"
                    />
                    <label
                        class="form-check-label"
                        :for="'question_' + element.id"
                        >{{ element.question }}</label
                    >
                </div>
            </div>
        </draggable>
        <div class="form-group row">
            <div class="col-md-12">
                <br />
                <button class="btn btn-success pull-right" @click="save">
                    Actualizar
                </button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        model_id: Number,
    },
    data() {
        return {
            arrayModels: [],
            arrayModelOrder: [],
        };
    },
    methods: {
        showActionSuccess(message) {
            const Toast = this.$swal.mixin({
                toast: true,
                icon: "success",
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
            });

            Toast.fire({
                type: "success",
                title: message,
            });
        },
        save() {
            let _this = this;
            axios
                .put(
                    "/api/contests/config-questions/order/" + _this.model_id,
                    _this.arrayModels
                )
                .then(function (response) {
                    _this.showActionSuccess("Actualizacion exitosa!");
                });
        },
    },
    created() {
        let _this = this;
        axios
            .get("/api/contests/config-questions?paginate=false&contest_id=" + _this.model_id)
            .then(function (response) {
                _this.arrayModels = response.data;
            });
    },
};
</script>
